import { ICollection } from 'types/collection';
import { ISanitizedCompany } from 'types/company';

export class CollectionSlugFormatError extends Error {
  name: string = 'CollectionSlugFormatError';
}

export const parseCollectionSlug = (
  collectionSlug: string,
): [name: string, id: string] => {
  const matches = collectionSlug.match(/(^[a-z\d-]+)-([a-zA-Z0-9]+)$/);

  if (!matches) {
    throw new CollectionSlugFormatError(
      `Slug "${collectionSlug} cannot be parsed."`,
    );
  }

  const [, name, id] = matches;

  return [name, id];
};

export const normalizeName = (name: string) => {
  return name
    .toLocaleLowerCase()
    .replace(/\u00df/g, 'ss')
    .replace(/\u00e4/g, 'ae')
    .replace(/\u00f6/g, 'oe')
    .replace(/\u00fc/g, 'ue')
    .replace(/[\W_]+/g, '-')
    .replace(/^-|-$/g, '');
};

interface IGetCollectionUrlParams {
  collection: ICollection;
  company: ISanitizedCompany;
}
export const getCollectionPath = ({
  collection,
  company,
}: IGetCollectionUrlParams) => {
  const collectionSlug = normalizeName(collection.name);

  return `/${company.slug}/collection/${collectionSlug}-${collection.id}`;
};
